import { Alert, Button, Input } from "reactstrap";
// @ts-ignore
import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";
import AppSpinner from "../../elements/AppSpinner";
import { useState } from "react";

interface Props {
  onSubmit: (password: string) => void;
  submitting: boolean;
  error: string;
  title?: string;
}

export default function PasswordProtectedView({
  onSubmit,
  submitting,
  error,
  title = "Enter Password To View This Page",
}: Props) {
  const [password, setPassword] = useState("");

  return (
    <div className="h-100vh w-100 d-flex justify-content-center align-items-center">
      <div
        className="border p-4 rounded-sm btn-oauth w-100"
        style={{ maxWidth: 400 }}
      >
        <img
          alt=""
          src={GCLogo}
          style={{ width: 180, marginRight: 50, marginLeft: 10 }}
          className="mb-4"
        />
        <h4>{title}</h4>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(password);
          }}
        >
          <Input
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={submitting}
          />
          <Button
            color="primary"
            disabled={submitting}
            className="mt-2"
            type="submit"
          >
            {submitting ? <AppSpinner color="white" /> : "Submit"}
          </Button>
        </form>
        {error && (
          <Alert color="danger" className="py-2 px-4 mt-2 mb--2">
            {error}
          </Alert>
        )}
      </div>
    </div>
  );
}
